/* eslint import/prefer-default-export:off */
/* eslint react/prefer-stateless-function:off */

import moment from 'moment';

const formattedDate = date => moment(date).format('DD/MM/YYYY');

export { formattedDate };
